(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["featured-collection"]) return;
  try {
    

    espiritu.common.initFeaturedSlider();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
    espiritu.utils.phoneFormat($('.shop-phone'));

  } catch(e) { console.error(e); }
})();

})();
